import { createContext } from 'react';
import { PersonExtended } from '@sdir/httpclient/lib/clients/core/externallookup';
import { Loadable } from '../../types';

export interface ICurrentRegisteredPersonContext {
  person: Loadable<PersonExtended>;
  refresh?: () => void;
}

export const CurrentRegisteredPersonContext = createContext<ICurrentRegisteredPersonContext>({
  person: {
    loading: false,
    result: null,
    error: null,
  },
});
